import { getRules, getMultiComplexRules } from './rules'
import Input from '../components/FormControl/Input'
import Checkbox from '../components/Checkbox'
import SingleCheck from '../components/Checkbox/SingleCheck'
import Radio from '../components/Radio'
import MultiComplexItem from '../components/MultiComplexItem/index.vue'
import ComplexItem from '../components/ComplexItem'
import CatProp from '../components/ComplexItem/CatProp'
import Specification from '../components/ComplexItem/Specification'
import Images from '../components/ComplexItem/Images'
import Image from '../components/Upload/Image'
import Select from '../components/Select'
import Editor from '../components/Editor'
import store from '@/store'

// 采购地的isShowFn
function _globalStockShowFn(tjbForm) {
    return tjbForm.globalStockNav === '1'
}
// 发货时间天数的isShowFn
function _tjbDeliveryTimeShowFn(tjbForm) {
    return tjbForm.deliveryTimeType === '2'
}
// 发货时间天数的isShowFn
function _openSkuDeliveryTimeShowFn(tjbForm) {
    return tjbForm.deliveryTimeType === '2' && window._globel_vm?.$store.getters.tjbData?.pureType !== 1
}


export const needLimitImgFields = ['images', 'verticalImage'];
// 一些图片的限制生成
function _genImagesLimit(item) {
    // 若不是需要处理的图片字段就不处理了
    if (!needLimitImgFields.includes(item.name)) {
        return {}
    }
    // 生成符合图片上传组件适用的属性
    let limits = {
        limitWidth: [0, 0],
        limitHeight: [0, 0]
    }
    let {maxTargetSizeRule, maxImageSizeRule, minImageSizeRule, tipRule} = item._oriRules || {}
    if (maxTargetSizeRule) {
        limits.limitSize = Number(maxTargetSizeRule)
        limits._needLimit = true;
    }
    if (maxImageSizeRule) {
        let maxS = maxImageSizeRule.split('x')
        limits.limitHeight[1] = maxS[1]
        limits.limitWidth[1] = maxS[0]
        limits._needLimit = true;
    }
    if (minImageSizeRule) {
        let minS = minImageSizeRule.split('x')
        limits.limitHeight[0] = minS[1]
        limits.limitWidth[0] = minS[0]
        limits._needLimit = true;
    }
    if (tipRule) {
        // 有些图片限制需要通过tipRule描述，如比例
        // 一些正则匹配
        let regAspectRatio = /横竖比必须为(\d+：\d+)/
        let regMinWidth = /最小长度为(\d+)/

        // 匹配比例 
        let aspectRatio = tipRule.match(regAspectRatio);
        if (aspectRatio) {
            aspectRatio = aspectRatio[1];
            let _asp = aspectRatio.split('：')
            limits.aspectRatio = _asp[0] / _asp[1]
            limits.aspectRatioText = aspectRatio
            limits._needLimit = true;
        }

        // 匹配最小宽度
        let minWidth = tipRule.match(regMinWidth)
        if (minWidth) {
            minWidth = minWidth[1]
            limits.limitWidth[0] = minWidth
            limits._needLimit = true;
        }

    }
    return limits
}

// 一些表单控件的展现需要依赖另一些
function _genIsShowFn(item) {
    if (item.name === "globalStock") {
        // 采购地的一些字段处理
        item.children.forEach(child => {
            if (["country", "stockType"].includes(child.name)) {
                child.isShowFn = _globalStockShowFn
            }
        })
    } else if (item.name === "departurePlace") {
        // 发货地也要依据采购地的isShowFn来展示
        item.isShowFn = _globalStockShowFn
    } 
    else if (["tbDeliveryTime"].includes(item.name)) {
        item._preText = `付款后`
        item._suffixText = `天内发货<span style="margin-left: 5px;" class="tips">(按商品规格设置不生效时，将按款维度发货时间铺货)</span>`
        item.isShowFn = _tjbDeliveryTimeShowFn
    } else if (item.name === "openSkuDeliveryTime") {
        item.isShowFn = _openSkuDeliveryTimeShowFn
    } else if (item.name === "deliveryTimeType") {
        item.isShowTipFn = (form) => {
            return ["0", "3"].includes(form.deliveryTimeType)
        }
        // 产品文档需要把大于48小时发货改为全款预售
        let item48 = item.options.find(item => item.displayName === "大于48小时发货" && item.value === "2")
        if (item48) {
            item48.warning = "平台指定类目才有该权限，若类目无权限将禁用该项"
        }
    }
    return item
}

/**
 * 是否用 checkbox 组件
 * @param {*} item 
 * @returns 
 */
const isCheckbox = (item) => {
    const { name, options } = item
    if (options.length === 2) {
        if (
            options.some(item => item.value === '1' && item.displayName === '是') &&
            options.some(item => item.value === '0' && item.displayName === '否')
        ) {
            return true
        } else {
            return false
        }
    }
}

const typeMap = {
    // INPUT，说明当前field的值为文本输入型。
    INPUT: item => {
        const { valueTypeRule, properties, name, parentName } = item
        
        // 特殊处理
        // name 为 "desc" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["desc", "wirelessDesc"].includes(name)) {
            return {
                component: Editor,
                props: {dataSource: item, name, parentName}
            }
        }


        if (Array.isArray(properties) && properties.length > 0) {
            return {
                component: Input,
                props: { dataSource: item, name, parentName }
            }
        } else if (valueTypeRule === 'decimal') {
            return {
                component: Input,
                props: { min: 0, precision: 2, name, parentName }
            }
        } else if (valueTypeRule === 'integer') {
            return { component: Input, props: { min: 1, precision: 0, name, parentName } }
        } else if (valueTypeRule === 'url') {
            return {
                component: Input,
                props: {name, parentName}
            }
        } else if (valueTypeRule === 'date') {
            return {
                component: Input,
                props: {
                    style: {
                        width: '100%'
                    },
                    name,
                    parentName
                }
            }
        } else if (valueTypeRule === 'time') {
            return {
                component: Input,
                props: {
                    style: {
                        width: '100%'
                    },
                    format: 'YYYY-MM-DD HH:mm:ss',
                    showTime: { defaultValue: moment('00:00:00', 'HH:mm:ss') },
                    name,
                    parentName
                }
            }
        } else {
            return {
                component: Input,
                props: {
                    placeholder: '请输入',
                    name,
                    parentName
                }
            }
        }
    },
    // MULTIINPUT ，说明当前field的值为多行文本输入型。
    MULTIINPUT: item => {
        const { name } = item
        return { component: Input, props: { name } }
    },
    // SINGLECHECK，说明当前field的值为单选输入型，类似于radio。
    SINGLECHECK: item => {
        const { options, name, parentName, tipRule } = item
        if (parentName && parentName === 'catProp') {
            let canInputCustom = false
            if (!('p-20000' === name) && tipRule && tipRule.includes("该属性支持自定义输入，自定义输入值请填写至value标签inputValue属性, value标签内容为任意负数")) {
                canInputCustom = true
            }
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, name, "value-key": "value", vk: '0', style: "width:100%;", canInputCustom, clearNoExistValue: true } }
        } else if(name == 'openSkuDeliveryTime') {
            return { component: SingleCheck, props: {extraLabel: '按宝贝规格设置发货时间',dataSource: _genIsShowFn(item), name, label: 's'}}
        }
        else if (isCheckbox(item)) {
            return { component: SingleCheck, props: {dataSource: item, name, label: 's'}}
        } else if(name == 'tbDeliveryTime') {
            return { component: Select, props: { dataSource: _genIsShowFn(item), name } }
        }
        else if (options.length <= 3 && name !== 'catProp'  || item.source === 'saleProp') {
            return { component: Radio, props: { dataSource: _genIsShowFn(item), name } }
        }
        else {
            return { component: Select, props: { dataSource: _genIsShowFn(item), name } }
        }
    },
    // MULTICHECK ，说明当前field的值为多选输入型，类似于checkbox。
    MULTICHECK: item => {
        const { options, name, parentName } = item
        if (parentName && parentName === 'catProp') {
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, multiple: true, name, "value-key": "value", style: "width:100%;", clearNoExistValue: true } }
        } else {
            return { component: Select, props: { dataSource: item, multiple: true, name } }
        }
    },
    // COMPLEX ，说明当前field的值为复合结构，表示数据的聚合。
    COMPLEX: item => {
        const { name } = item
        // 特殊处理几种复合型控件
        // 1. catProp 为类目属性
        // 2. saleProp 为销售属性（同其他平台的规格信息）
        // 3. images 为主图+宝贝图+白底图（同其他主图组件，至于区分主图、宝贝图、白底图交由后端发布时后端处理）
        // 4. verticalImage 为长图，也用images的组件，在组件里作name的区别判断
        const specialCompMap = {
            "catProp": CatProp,
            "saleProp": Specification,
            "images": Images,
            "verticalImage": Image
        }

        return {
            component: specialCompMap[name] || ComplexItem,
            props: { dataSource: _genIsShowFn(item), name, extraAttr: {
                ..._genImagesLimit(item)
            }}
        }
    },
    // MULTICOMPLEX ，说明当前field的值为复合结构，与complex有差别的在于multiComplex的field是可以有多份数据实例样本。
    MULTICOMPLEX: item => {
        const { name } = item
        return { component: MultiComplexItem, props: { dataSource: item, name } }
    }
}

/**
 * 生成field
 * @param {*} fields 
 * @returns 
 */
const generateField = (fields, parentName) => {
    return fields.reduce((field, item) => {
        // 暂时屏蔽非类目属性下的多实例符合类型
        if (item.type === 'MULTICOMPLEX' && parentName !== 'catProp') {
            return field
        }

        if (item.children) {
            item.children = generateField(item.children, item.name)
        }
        parentName && (item.parentName = parentName)
        item.rules = item.type === 'MULTICOMPLEX' ? getMultiComplexRules(item)  : getRules(item) // rule
        item.component = typeMap[item.type](item)
        if (item.name === 'quantity') {
            // 纯商品需要放开总数量
            let initTjbDetail = store.state.tjbForm.initTjbDetail;
            // 总数量需要禁用输入，值通过skuList中的skuQuantity 求合得来
            if(initTjbDetail && initTjbDetail.pureType) {
                item.component.props.disabled = false;
            } else {
                item.component.props.disabled = true;
            }
            // 且需要给予提示语
            item.tipRule = item.tipRule && (item.tipRule instanceof Array) ? item.tipRule.push('此处是商品所有销售规格总库存数量, 若需修改请在商品明细表格内修改对应库存')
            : ['此处是商品所有销售规格总库存数量, 若需修改请在商品明细表格内修改对应库存']
        }
        return field.concat(item)
    }, [])
}


/**
 * 获取field
 * @param {*} fields 
 * @returns 
 */
export const getField = (fields) => {
    if (!Array.isArray(fields) || fields.length <= 0) return []
    return generateField(fields)
}